import { STORY_TYPES } from '../lib/playbookModel.js';
import DoanVan from './DoanVan.jsx';

/**
 * Ảnh trong bài. Luôn nằm gọn trong cột chữ, có width/height để trình duyệt
 * giữ chỗ trước, và hai kiểu hiển thị:
 *  - 'rong': cắt 16:9, đều nhịp như ảnh báo chí
 *  - 'nguyen-ban': giữ tỷ lệ gốc (ảnh chụp slide, bảng số), giới hạn chiều cao
 */
export function PlaybookFigure({ image, priority = false }) {
  if (!image?.url) return null;
  return <figure className={`pb-figure pb-figure-${image.fit || 'rong'}`}>
    <div className="pb-figure-frame">
      {image.urlHep ? <picture>
        <source media="(max-width: 640px)" srcSet={image.urlHep} />
        <img src={image.url} alt={image.alt || ''} loading={priority ? 'eager' : 'lazy'} decoding="async" />
      </picture> : <img src={image.url} alt={image.alt || ''} width={image.width || undefined} height={image.height || undefined}
        loading={priority ? 'eager' : 'lazy'} decoding="async" />}
    </div>
    {(image.caption || image.credit) && <figcaption>
      {image.caption}{image.credit && <span className="pb-credit">{image.caption ? '. ' : ''}Ảnh: {image.credit}</span>}
    </figcaption>}
  </figure>;
}

export function PlaybookQuote({ quote }) {
  if (!quote?.text) return null;
  return <blockquote className="pb-quote"><p>{quote.text}</p>{quote.by && <cite>{quote.by}</cite>}</blockquote>;
}

export function StoryBadge({ type }) {
  const t = STORY_TYPES[type];
  return t ? <span className={`pb-badge pb-badge-${type}`}>{t.label}</span> : null;
}

/** Bảng trong bài — dùng chung cho trang bài viết và phần xem trước ở trang quản trị. */
export function PlaybookTable({ table, nhan = '' }) {
  if (!table) return null;
  return <div className="pb-table-wrap" role="region" aria-label={table.caption || nhan || 'Bảng so sánh'} tabIndex={0}>
    <table className="pb-table">
      {table.caption && <caption>{table.caption}</caption>}
      <thead><tr>{table.headers.map((h, i) => <th key={i} scope="col">{h}</th>)}</tr></thead>
      <tbody>{table.rows.map((row, r) => <tr key={r}>{row.cells.map((c, i) => <td key={i}><DoanVan chu={c} /></td>)}</tr>)}</tbody>
    </table>
  </div>;
}
